import React from "react";
import { useMapContext } from "../../Contexts/MapContext";
import { SketchProps } from "./SketchProps";

export const DrawnItems = (): JSX.Element => {
    const { drawnFeatures } = useMapContext();

    return (
        <div className="scrollable-content-container">
            <div className="scrollable-content">
                {drawnFeatures &&
                    drawnFeatures.map((f) => <SketchProps feature={f} key={f.get("TEMPID") + "note"}></SketchProps>)}
            </div>
        </div>
    );
};
